/*
  OZ 2026-10-16: on phones the pinned purple header slides away while the shopper scrolls down and comes back as soon
  as they scroll up (Dereck). It always shows at the top of the page, while the mobile menu is open, and under the
  search or upsell layers. Desktop is untouched. Styles: theme.css (html.oz-hdr-away).
*/
(function () {
  'use strict';
  var header = document.getElementById('shopify-section-header');
  if (!header) return;
  var phone = window.matchMedia('(max-width: 999px)');
  var root = document.documentElement;
  var lastY = window.pageYOffset, ticking = false;

  function update() {
    ticking = false;
    var y = Math.max(0, window.pageYOffset);
    // stuck at the top (the announcement bar scrolled away): theme.css draws a purple skirt above the header, so no
    // sliver of the page shows over it when the phone rounds its position to device pixels (Dereck 2026-10-16)
    var bar = document.getElementById('shopify-section-announcement-bar');
    var stuck = phone.matches && y > (bar ? bar.offsetHeight : 0);
    if (root.classList.contains('oz-hdr-stuck') !== stuck) root.classList.toggle('oz-hdr-stuck', stuck);
    var dy = y - lastY;
    if (Math.abs(dy) < 6 && y > 0) return;
    var menuOpen = !!document.querySelector('[data-action="toggle-menu"][aria-expanded="true"]');
    var locked = root.classList.contains('oz-search-lock') || root.classList.contains('oz-up-lock');
    // hide only once the page has moved past the announcement bar and the header (offsetTop follows the stuck header,
    // so the distance is measured from the page top), never with a gap at the top of the page
    var away = phone.matches && !menuOpen && !locked && dy > 0 && y > 2 * header.offsetHeight;
    root.classList.toggle('oz-hdr-away', away);
    lastY = y;
  }
  // Rewards and chat bubbles show at all times on desktop and hide on phones (theme.css; Dereck 2026-10-17). The Oz
  // Rewards launcher (Smile) is the full pill with its text only when the pill fits in the gap left of the page content;
  // otherwise it is the gift alone in a circle, as on phones. Measure the content's left edge on this page and set
  // html.oz-rewards-full when the pill (~170px plus margins) fits.
  // A card or the collection wrap draws its own frame, so its box is the edge. A .container is often full width around
  // narrower content (the Klaviyo signup form is centred in one), so its edge is what is drawn inside it, kept within
  // its padding so carousel slides parked off screen do not count.
  var LEFT_NEED = 200;
  // Smile's launcher is a same-origin iframe; its own CSS pads the button for a 60px frame, so the circle only needs
  // the text hidden inside it. Smile can redraw the frame, so this runs on every fit and when the frame appears.
  var COMPACT_CSS = '.launcher-text{display:none!important}.launcher-content-container{justify-content:center!important}';
  function styleRewards() {
    var f = document.querySelector('.smile-launcher-frame-container iframe');
    var d;
    try { d = f && f.contentDocument; } catch (e) { return; }
    if (!d || !d.head) return;
    var s = d.getElementById('oz-rewards-compact');
    var full = root.classList.contains('oz-rewards-full');
    if (full && s) s.remove();
    if (!full && !s) {
      s = d.createElement('style');
      s.id = 'oz-rewards-compact';
      s.textContent = COMPACT_CSS;
      d.head.appendChild(s);
    }
  }
  var DRAWN = 'img, video, svg, iframe, h1, h2, h3, h4, h5, h6, p, a, button, input, select, textarea, label, li';
  function fitBubbles() {
    var main = document.getElementById('main');
    if (!main) return;
    var l = Infinity, r = -Infinity;
    Array.prototype.forEach.call(main.querySelectorAll('.container, .card, .oz-plp__wrap'), function (el) {
      var b = el.getBoundingClientRect();
      if (b.width < 200 || b.height < 40) return;
      if (!el.classList.contains('container')) {
        l = Math.min(l, b.left);
        r = Math.max(r, b.right);
        return;
      }
      var cs = getComputedStyle(el);
      var cl = b.left + (parseFloat(cs.paddingLeft) || 0), cr = b.right - (parseFloat(cs.paddingRight) || 0);
      Array.prototype.forEach.call(el.querySelectorAll(DRAWN), function (d) {
        var e = d.getBoundingClientRect();
        if (!e.width || !e.height || e.right <= cl || e.left >= cr) return;
        l = Math.min(l, Math.max(cl, e.left));
        r = Math.max(r, Math.min(cr, e.right));
      });
    });
    if (l !== Infinity) root.classList.toggle('oz-rewards-full', l >= LEFT_NEED);
    styleRewards();
  }
  var ft = null;
  window.addEventListener('resize', function () { clearTimeout(ft); ft = setTimeout(fitBubbles, 120); });
  window.addEventListener('load', fitBubbles);
  // an accordion opening or an app block arriving changes what is drawn without a resize
  if (window.ResizeObserver && document.getElementById('main')) {
    new ResizeObserver(function () { clearTimeout(ft); ft = setTimeout(fitBubbles, 120); }).observe(document.getElementById('main'));
  }
  // Smile injects its launcher after the page loads
  if (window.MutationObserver) {
    new MutationObserver(function () {
      var f = document.querySelector('.smile-launcher-frame-container iframe');
      if (f && !f.ozWatched) {
        f.ozWatched = true;
        f.addEventListener('load', styleRewards);
        styleRewards();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  fitBubbles();

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }, { passive: true });
})();
